<div class="flex flex-col">
    <button type="button" (click)="navigate()" class="text-primary-800">
        {{ params.value }}
    </button>
</div>
